import { Box } from "@outschool/backpack";
import { ContentfulVisualLink } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { onlineClassesPath } from "@outschool/routes";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import exploreImg from "../../../images/tutoring/explore-blob.svg";
import { BlobButton } from "./BlobButton";
import PageSectionTitle from "./PageSectionTitle";

export default function PopularTutoringSubjects({
  subjects
}: {
  subjects: Pick<ContentfulVisualLink, "text" | "image" | "path" | "pathB">[];
}) {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\PopularTutoringSubjects"
  );
  const isMobile = useIsMobile();

  return (
    <Box>
      <PageSectionTitle
        title={t("Popular Tutoring Subjects")}
        align={`${isMobile ? "center" : "inherit"}`}
      />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(12rem, 1fr))",
          gap: "1rem",
          justifyContent: "space-between",
          alignItems: "start"
        }}
      >
        {subjects.map(({ text, image, pathB }, index) => {
          return text && image?.url && pathB ? (
            <BlobButton
              key={`${text}-${index}`}
              title={text}
              imageSrc={image?.url}
              href={pathB}
            />
          ) : (
            <></>
          );
        })}

        <BlobButton
          title={t("Explore more")}
          imageSrc={exploreImg}
          href={onlineClassesPath("tutoring")}
        />
      </Box>
    </Box>
  );
}
